import { Suspense } from "react";

import { Outlet } from "react-router-dom";

// import { PersistenceProvider } from "providers/persistence/PersistenceProvider";

import GlobalSidebar from "@/components/GlobalSidebar/GlobalSidebar";
import Loader from "components/Loader";

import { AuthGuard } from "./guards/AuthGuard";

const PrivatePageLayout = () => {
  return (
    <AuthGuard redirectTo="/login" access="private">
      {/* <PersistenceProvider> */}
      <GlobalSidebar />
      <main>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </main>
      {/* </PersistenceProvider> */}
    </AuthGuard>
  );
};

export { PrivatePageLayout };
